import { render, staticRenderFns } from "./ComponentAveragesTable.vue?vue&type=template&id=78edbe32&scoped=true&"
import script from "./ComponentAveragesTable.vue?vue&type=script&lang=js&"
export * from "./ComponentAveragesTable.vue?vue&type=script&lang=js&"
import style0 from "./ComponentAveragesTable.vue?vue&type=style&index=0&id=78edbe32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78edbe32",
  null
  
)

export default component.exports